<template>
    <div class="app-empty">
        <div class="app-empty_img"/>
        <div class="app-empty_text" v-html="text"></div>
        <div class="app-empty_content">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'app-empty',
    props: {
        text: {
            type: String,
            default: '暂无数据'
        }
    }
};
</script>

<style scoped lang="scss">
.app-empty {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    .app-empty_img {
        width: 112px;
        height: 112px;
        background-image: var(--empty-bg);
        background-size: cover;
    }
    .app-empty_text {
        text-align: center;
        line-height: 24px;
    }
    .app-empty_content {
        margin-top: 24px;
    }
}
</style>
